import React from 'react';
import styles from './explore.module.css'
const UserCard=(props)=>{
    return(
        <div className={styles.CardCon}>
            <div className={styles.CardTop}>
                <div className={styles.ppCon}>
                <img src="https://vsam.me/userimages/23-28-12-20-05-52-01-28-12-20.png" atl="pp"/>
                </div>
                <div className={styles.CardUserInfo}>
                    <div>arham_choudhary</div>
                    <span>Arham Choudhary</span>
                    <br/>
                    <span>Developer</span>

                </div>

            </div>
            <div className={styles.Cardmid}>
            <div className={styles.joined}>
            <div><strong> Followed By</strong></div>
                    <div>
                    <img  src="https://organicthemes.com/demo/profile/files/2018/05/profile-pic.jpg"/>
                    <img  src="https://cultivatedculture.com/wp-content/uploads/2019/12/LinkedIn-Profile-Picture-Example-Tynan-Allan.jpeg"/>
                    <img  src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQcsjMZRq5tDcW-zaTDcZL01NOCrDYLglPqfQ&usqp=CAU"/>
                    <img  src="https://organicthemes.com/demo/profile/files/2018/05/profile-pic.jpg"/>
                   </div>
                   <div> and 10 others.</div>
                </div>

            </div>
            <div style={{justifyContent:"center"}} className={styles.action}>
             
             {props.buttons}
             
               
                
            </div>


        </div>
    )
}


export default UserCard